import Vue from "vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import App from "./App.vue";
import router from "./router";
import VueClipboard from "vue-clipboard2";

Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(VueClipboard);

router.beforeEach(function (to, from, next) {
    if (to.path == "/login" || localStorage.getItem("token")) {
        next();
    } else {
        next("/login");
    }
});

new Vue({
    router,
    render: h => h(App)
}).$mount('#app');
